// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-PasswordForgotForm__wrapper","form":"c-PasswordForgotForm__form","loading":"c-PasswordForgotForm__loading"};